import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from '@olxbr/ds-web'
import { System } from '@olxbr/olx-icons'
import { CircularIntegerProgress } from '../../molecules'
import { PROFILE_URL } from '../../../settings'

const ProgressCircleWrapper = styled.div`
  width: var(--spacing-8);
  height: var(--spacing-8);
`

const strokeColor = {
  1: 'var(--color-feedback-error-90)',
  2: 'var(--color-primary-90)',
  3: 'var(--color-feedback-attention-90)',
  4: 'var(--color-feedback-success-90)',
}

const AwardIcon = styled(System.Award)`
  color: ${({ color }) => color};
`

export const LevelProgress = ({ stepsCompleted, steps, publicAccountId }) => {
  const stepsLeft = steps - stepsCompleted
  return (
    <div className="flex items-center">
      <ProgressCircleWrapper>
        <CircularIntegerProgress
          strokeWidth={8}
          steps={steps}
          stepsCompleted={stepsCompleted}
          styles={{
            path: {
              strokeLinecap: 'butt',
              stroke: strokeColor[stepsCompleted],
            },
          }}
        >
          <AwardIcon color={strokeColor[stepsCompleted]} />
        </CircularIntegerProgress>
      </ProgressCircleWrapper>
      {stepsLeft === 0 ? (
        <div className="flex flex-col items-start ml-3">
          <span className="typo-body-medium font-semibold">
            Parabéns! Você alcançou o nível máximo.
          </span>
          <Link size="small" href={`${PROFILE_URL}/${publicAccountId}`}>
            Ver meu perfil
          </Link>
        </div>
      ) : (
        <div className="flex flex-1 flex-col items-start ml-3">
          <span className="typo-body-medium font-semibold">
            {stepsLeft > 1 ? 'Restam' : 'Resta'} apenas {stepsLeft}{' '}
            {stepsLeft > 1 ? 'etapas' : 'etapa'}!
          </span>
          <span className="typo-body-small font-regular">
            Complete as etapas para atingir o nível máximo de confiança.
          </span>
        </div>
      )}
    </div>
  )
}

LevelProgress.propTypes = {
  stepsCompleted: PropTypes.number.isRequired,
  steps: PropTypes.number.isRequired,
  publicAccountId: PropTypes.string.isRequired,
}

LevelProgress.defaultProps = {}
